var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconGi = function SvgIconGi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9F9",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#D80027"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24c5.16 0 9.558-3.256 11.253-7.825H.746C2.442 20.745 6.84 24 12 24M16.696 9.914V8.348h.521V7.305h-1.043v.522H15.13v-.522h-1.043v1.043h.522v1.566h-1.044V6.26h.522V5.218h-1.044v.522h-.521v-.522h-1.044v.522h-.522v-.522H9.913v1.043h.522v3.653H9.39V8.348h.522V7.305H8.869v.522H7.826v-.522H6.783v1.043h.521v1.566H6.261v4.174h11.478V9.914z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M12 13.565a1.565 1.565 0 0 0-.522 3.041v2.177H9.913v2.087h2.609v-4.264a1.566 1.566 0 0 0-.522-3.04m0 2.087a.522.522 0 1 1 0-1.043.522.522 0 0 1 0 1.043"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconGi;